const masterEn = {
    country: require('../../lang/en/master/Country').default,
    district: require('../../lang/en/master/District').default,
    pin: require('../../lang/en/master/Pin').default,
    place: require('../../lang/en/master/Place').default,
    state: require('../../lang/en/master/State').default,
    tehsil: require('../../lang/en/master/Tehsil').default,
    nature: require('../../lang/en/master/Nature').default,
    structure: require('../../lang/en/master/Structure').default,
    crop: require('../../lang/en/master/Crop').default,
    bioMaster: require('../../lang/en/master/BioMaster').default,
    diseaseMaster: require('../../lang/en/master/DiseaseMaster').default,
    stage: require('../../lang/en/master/Stage').default,
    requestType: require('../../lang/en/master/RequestType').default,
};

export default masterEn;